export const baseUrl = 'https://lpapi.pblinq.com/customerCare'
export const localBaseUrl = 'http://lpapi.localtest.me/customerCare'
export const translateBaseUrl = 'https://translate.googleapis.com/translate_a/single?client=gtx';
export const siteKey = '6Lc1bfMZAAAAADcPFO228N7cWRCvXR8xyWk6YPcZ';

export var config = null;
switch (window.location.hostname) {
    case 'alerts.cupongoo.com':
        document.documentElement.style.setProperty('--headerBgColor', '#c5e417');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/cupongoo_logo.png',
            translate: false
        };
    break;
    case 'alerts.deals4you.co':
        document.documentElement.style.setProperty('--headerBgColor', '#007ad8');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/deals4you.png',
            translate: false
        };
    break;
    case 'alerts.mobivity.co':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/mobivity-logo.png',
            translate: false
        };
    break;
    case 'alerts.fun4all.cc':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/fun4all.png',
            translate: false
        };
    break;
    case 'info.deal2play.co':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/deal2play.png',
            translate: true
        };
    break;
    case 'info.bequizzled.co':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/bequizzled.png',
            translate: true
        };
    break;
    case 'info.mobivity.co':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/mobivity-logo.png',
            translate: true
        };
    break;     
    case 'localhost':
    case 'info.doublefun.co':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/doublefun.png',
            translate: true
        };
    break;
    case 'info.play2shop.co':
        document.documentElement.style.setProperty('--headerBgColor', '#fff');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/play2shop.png',
            translate: true
        };
    break;
    default:
    {
        document.documentElement.style.setProperty('--headerBgColor', '#2f3069');
        document.documentElement.style.setProperty('--backgroundUrl', 'no-repeat url("/img/bg.jpg")');
        config = {
            logo: '/img/customercare-today-white.png',
            translate: true
        };
    }
    break;
}

